import React, { ReactNode } from 'react';
import { ReactComponent as HexagonIcon } from 'assets/icons/hexagon.svg';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { MenuHorizontalIcon } from 'cokitchen-icons';

export type PolygonItemType = {
  name: string;
  icon?: ReactNode;
  onClick?: () => void;
  className?: string;
};
type PolygonItemProps = {
  list: PolygonItemType[];
  color: string;
  name: string;
  onClick: () => void;
};
const PolygonItem = ({ list, color, name, onClick }: PolygonItemProps) => {
  return (
    <div onClick={onClick} className='flex gap-3 items-center'>
      <HexagonIcon color={color} />
      <label className='grow capitalize text-sm font-medium'>{name}</label>
      {list.length !== 0 && (
        <Dropdown
          content={
            <MenuHorizontalIcon className='w-6 h-6 p-[4px] rounded-full cursor-pointer transition-all duration-200 hover:bg-gray-4 hover:text-white border border-gray-13 text-gray-4' />
          }>
          <DropdownList>
            {list.map((item, index) => (
              <DropdownItem
                key={index}
                onClick={() => {
                  item.onClick?.();
                }}
                className={`${item.className} flex items-center`}
                buttonClassName='py-[6px] px-2 text-sm'>
                <span className='w-[26px] h-[26px] rounded-full text-gray-5 shadow-md flex items-center justify-center mr-4'>
                  {item.icon}
                </span>
                {item.name}
              </DropdownItem>
            ))}
          </DropdownList>
        </Dropdown>
      )}
    </div>
  );
};

export default PolygonItem;
